export const MEDIA_CONTENT_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
}
